import { type ReactNode, isValidElement } from 'react';

import { ErrorCode } from './graphql';

function onlyText(message: ReactNode): string {
  if (typeof message === 'string') {
    return message;
  }
  if (Array.isArray(message)) {
    return message.map(onlyText).join('');
  }
  if (isValidElement(message)) {
    return onlyText(message.props.children);
  }
  return '';
}

export class GraphQLAppError extends Error {
  readonly code?: ErrorCode;
  readonly enrichedMessage?: ReactNode;

  constructor(message: string | ReactNode, code?: ErrorCode) {
    super(onlyText(message));
    this.name = 'GraphQLAppError';
    this.code = code;
    this.enrichedMessage = message;
  }
}

export const isNotFoundError = (error: unknown): error is GraphQLAppError =>
  error instanceof GraphQLAppError && error.code === ErrorCode.NotFound;

export const isPermissionDeniedError = (
  error: unknown,
): error is GraphQLAppError =>
  error instanceof GraphQLAppError && error.code === ErrorCode.PermissionDenied;
